var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.data
    ? _c("article", { staticClass: "nti-product-info" }, [
        _c("h1", { staticClass: "nti-product-info__title" }, [
          _vm._v(_vm._s(_vm.data.title)),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "nti-product-info__container" }, [
          _c("div", { staticClass: "nti-product-info__image-container" }, [
            _c("img", { attrs: { src: _vm.data.imageUrl, alt: "" } }),
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass:
                "nti-product-info__scroll-to-configurator-button nti-button nti-button--confirm pardotTrackClick",
              on: { click: _vm.scrollToConfigurator },
            },
            [_vm._v(_vm._s(_vm.verifyLabel("configuratorTitle")))]
          ),
          _vm._v(" "),
          _c("div", {
            staticClass: "nti-product-info__list",
            domProps: { innerHTML: _vm._s(_vm.data.description) },
          }),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }